// set backlink value for browser native backward function
export function backlinkValue() {
    const backlinkValue = document.querySelector<HTMLDialogElement>(
        "[data-backlink-value]",
    );
    if (backlinkValue) {
        window.onpopstate = () => {
            history.replaceState(null, document.title, location.pathname);
            setTimeout(() => {
                // @ts-ignore
                location.replace(backlinkValue.dataset.backlinkValue);
            }, 0);
        };
        history.pushState({}, "");
    }
}
